import { render } from "./AppointmentList.vue?vue&type=template&id=e78ee980"
import script from "./AppointmentList.vue?vue&type=script&lang=js"
export * from "./AppointmentList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__